import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";

/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

// Phase 3 & 4----------------------------------------------------------------------------------------

// recuperer le fichier (photo) de l'avatar
export const getAvatarFileById = async (entity_type, entity_id, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/avatar/avatar/${entity_type}/${entity_id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// import d'un seul avatar
export const singleAvatarImport = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/avatar/importSingleAvatar`,
    payload,
    {
      headers: {
        ...setHeaders(context),
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
};

// import en masse de plusieurs avatars
export const multipleAvatarImport = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/avatar/importByClass`,
    payload,
    {
      headers: {
        ...setHeaders(context),
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
};

// suppression de plusieurs avatars
export const deleteAvatar = async (avatar_id, context) => {
  const response = await axios.delete(
    apiPaths.baseUrl + `/api/avatar/delete/${avatar_id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};
